import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        url: '=',
        uibModalInstance: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
        </div>
        <div class="modal-body">
            <div class="center mt1em">
                <img src="{{ vm.url }}" alt="">
            </div>
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/image/index.js